import React from 'react';
import paths from 'paths';

let BACKEND_URL = '';
if (typeof window != 'undefined' && typeof window.location == 'object') {
    BACKEND_URL = window.location.protocol + "//" + window.location.hostname;
}

export default {
    website: [
        {
            name: 'Connexion, inscription',
            QA: [
                {
                    question: "Je n'arrive pas à m'enregistrer et à créer mon pseudo.",
                    answer: <p>Votre pseudo doit être composé de lettres, de chiffres et de tirets, sans espace. Vous
                        devez être majeur pour créer un compte et un seul pseudo ne peut être créé par adresse
                        email.</p>
                },
                {
                    question: "Je n'ai pas reçu l'email de confirmation suite à mon enregistrement.",
                    answer: <ul>
                        <li>Si vous ne recevez pas notre émail immédiatement, vérifiez votre dossier "spam" et marquez
                            notre message comme "<b>non-spam</b>".
                        </li>
                        <li>Si vous ne retrouvez pas cet email, <a href={paths.contact.path}>contactez-moi</a> afin que
                            j'active votre compte.
                        </li>
                    </ul>
                },
                {
                    question: "J'ai reçu l'email pour confirmer mon enregistrement mais lorsque je clique sur le lien, je lis : \"l'URL d'activation est fausse\".",
                    answer: <ul>
                        <li>Assurez vous que le lien est identique à celui-ci:<br/>
                            https://www.bobtv.fr/register/activate.php?SID=xxxx <br/>
                            <b>xxxx</b> - sont 32 caractères alphanumériques.
                            Ce lien a pu être scindé en deux par votre messagerie. Vous devez rassembler les deux
                            parties par un copier/coller pour afficher le lien au format initial.
                        </li>
                        <li>Si vous ne parvenez pas à rassembler le lien <a
                            href={paths.contact.path}>contactez-moi</a> afin que j'active votre compte.
                        </li>
                    </ul>
                },
                {
                    question: "Je ne peux pas me connecter sur le site et je lis : \"Pseudo ou mot de passe incorrect\".",
                    answer: <ul>
                        <li>Vous utilisez un mot de passe incorrect. Cliquez sur le lien "<b>Mot de passe oublié?</b>",
                            il vous sera envoyé sur votre adresse email.
                        </li>
                        <li>Si vous n'avez pas reçu l'email de confirmation. <a
                            href={paths.contact.path}>Contactez-moi</a> afin que j'active votre compte.
                        </li>
                    </ul>
                },
                {
                    question: "Je ne peux pas me connecter sur le site. Lorsque j'entre mon pseudo et mon mot de passe, les champs s'effacent et je reste sur la page de connexion.",
                    answer: <ul>
                        <li>Supprimez les cookies à partir des Options Internet de votre ordinateur.</li>
                        <li>Vérifiez que l'heure et la date de votre horloge Windows sont à jour.</li>
                        <li>Redémarrez votre ordinateur.</li>
                    </ul>
                },
                {
                    question: "Je souhaite changer mon pseudo ou mon mot de passe.",
                    answer: <p>Vous pouvez modifier votre mot de passe et votre pseudo (seulement les abonnés XXL) à
                        partir de votre page profil.</p>
                },
                {
                    question: "Tout fonctionnait parfaitement auparavant et maintenant je ne parviens plus à me connecter au site ou à utiliser le tchat.",
                    answer: <p>Il est possible que votre ordinateur ait subi récemment une modification des fichiers
                        systèmes suite à l'installation d'un nouveau programme, d'un nouveau matériel ou d'une action de
                        votre part.<br/>
                        Vous pouvez restaurer les paramètres de votre ordinateur à son état précédent. Cette manoeuvre
                        est sans risque pour vos documents.<br/>
                        L'outil de "<b>restauration du système</b>" est accessible dans le menu "démarrer" de Windows :
                        Menu démarrer / Tous les programmes / Accessoires / Outil système / Restauration du
                        système.<br/>
                        Il suffit de restaurer le système à une date antérieure à l'apparition du problème.</p>
                },
            ]
        },
    ],
    room:
        [
            {
                name: 'Vidéo et audio',
                QA: [
                    {
                        question: "Je ne peux pas voir les webcams des autres utilisateurs.",
                        answer: <p>Assurez-vous d’utiliser un navigateur compatible et à jour dans sa dernière version.
                            Consultez la liste des OS et des navigateurs compatibles <a href="javascript: window.scrollTo(0, 0)">en haut de page</a>.</p>
                    },
                    {
                        question: "Je ne peux pas activer ma webcam et diffuser mon audio.",
                        answer: <ul>
                            <li>Sélectionnez et partagez vos sources audio et vidéo dans les paramètres de votre
                                navigateur.
                                Le navigateur demande votre autorisation lors de la première visite sur la salle de
                                tchat.
                            </li>
                            <li>Cliquez sur la petite icône "caméra", située dans la barre supérieure de votre
                                navigateur,
                                pour consulter les options de partage de votre webcam et de votre micro.
                            </li>
                            <li>Consultez les paramètres avancés de votre navigateur, puis les onglets "caméra" et
                                "micro".
                                Vérifiez que bobtv.fr n'est pas dans la liste des sites bloqués et que votre
                                caméra et votre micro ne sont pas eux-même bloqués.
                            </li>
                            <li>Téléchargez la mise à jour du pilote de votre webcam et de votre micro sur le site du
                                fabricant.
                            </li>
                        </ul>
                    },
                    {
                        question: "On entend mon audio avec un écho.",
                        answer: <p>Faites un clic droit sur l’icône haut-parleur se trouvant dans la barre inférieure de
                            votre écran et ouvrez le mixeur de volume de Windows.
                            Réduisez à 50% le volume dans la fenêtre de la salle de tchat.</p>
                    },
                    {
                        question: "Le tchat ralenti, les webcams se figent et je suis souvent déconnecté.",
                        answer: <div>
                            <p>Il n’est pas nécessaire d’avoir un ordinateur neuf et performant pour profiter pleinement
                                des
                                salles de tchat, la <b>configuration minimale recommandée</b> est :</p>
                            <ul>
                                <li>un processeur Intel Core i3,</li>
                                <li>4 Gb de RAM,</li>
                                <li>une connexion internet de 100 Mbs.</li>
                            </ul>

                            <p>Si le tchat n’est pas fluide malgré une configuration suffisante, <b>je vous
                                recommande</b> :
                            </p>
                            <ul>
                                <li>de réduire la qualité de votre vidéo dans les paramètres de la salle de tchat,</li>
                                <li>de ne pas ouvrir plus de 5 webcams simultanément,</li>
                                <li>de ne pas utiliser d’autres programmes ou applications en arrière plan,</li>
                                <li>de ne pas télécharger de fichiers, visionner des vidéos ou la télévision en ligne,
                                </li>
                                <li>de ne pas partager votre connexion Internet avec d’autres appareils,</li>
                                <li>de vous rapprocher de votre source Wifi ou de vous connecter en Ethernet,</li>
                                <li>de nettoyer votre système avec un logiciel gratuit tel que <a
                                    href="https://www.piriform.com/ccleaner/download" target="_blank">CCleaner</a>.
                                    Le logiciel retirera les fichiers inutilisés de vos disques durs, les raccourcis
                                    sans
                                    cible, les contrôles ActiveX,
                                    les fichiers d’aide, les entrées dans le registre, les fichiers temporaires,
                                    l’historique des sites visités, les cookies, les formulaires, etc...
                                </li>
                            </ul>
                        </div>
                    },
                    {
                        question: "L’affichage du texte sur la salle est trop petit ou trop gros.",
                        answer: <div>
                            <p>Modifier le pourcentage du Zoom de la page :</p>
                            <ul>
                                <li>dans les paramètres de votre navigateur,</li>
                                <li>en enfonçant la touche Ctrl et en tournant la molette de votre souris,</li>
                                <li>en enfonçant la touche Ctrl et les touches + ou - de votre clavier.</li>
                            </ul>
                        </div>
                    },
                    {
                        question: "Je veux diffuser de la musique directement à partir de la carte son de mon ordinateur Windows.",
                        answer: <div>
                            <p>Pour diffuser de la musique sur les salles vous devez sélectionner comme source audio le
                                mixage stéréo (stereo mix) de votre ordinateur.<br/>
                                Pour savoir si vous pouvez utiliser cette fonctionnalité sur votre ordinateur, faites un
                                clic droit sur l’icône haut-parleur se trouvant dans la
                                barre inférieure de votre écran et cliquez sur <b>Périphériques
                                    d’enregistrement</b> dans le
                                menu :
                                <img src={BACKEND_URL + "/images/faq/windows-10-activer-mixage-stereo-1.jpg"}/>
                            </p>
                            <p>La boîte de dialogue <b>Son</b>, onglet <b>Enregistrement</b> s’affiche. Si vous avez de
                                la
                                chance, l’icône <b>Mixage Stéréo</b> apparaît dans la
                                liste des périphériques d’enregistrement :
                                <img src={BACKEND_URL + "/images/faq/windows-10-activer-mixage-stereo-2.jpg"}/>
                            </p>
                            <p>Assurez-vous que la mention <b>Prêt</b> est affichée pour ce périphérique. Dans le cas
                                contraire, faites un clic droit sur l’icône <b>Mixage stéréo </b>
                                et choisissez <b>Activer</b> dans le menu :
                                <img src={BACKEND_URL + "/images/faq/windows-10-activer-mixage-stereo-3.jpg"}/>
                            </p>
                            <p>Si l’icône Mixage stéréo n'apparaît pas dans la boîte de dialogue <b>Son</b>, faites un
                                clic
                                droit dans la zone centrale de la boîte de dialogue et cochez
                                les entrées <b>Afficher les périphériques désactivés</b> et <b>Afficher les
                                    périphériques
                                    déconnectés</b> :
                                <img src={BACKEND_URL + "/images/faq/windows-10-activer-mixage-stereo-4.jpg"}/>
                            </p>
                            <p>Si l’icône Mixage stéréo n’apparaît toujours pas alors que les entrées <b>Afficher les
                                périphériques désactivés</b> et <b>Afficher les périphériques déconnectés </b>
                                sont cochées, mettez à jour le pilote de périphérique de votre carte audio en utilisant
                                le
                                pilote spécifique à votre carte mère.
                                En effet, Windows utilise un pilote audio par défaut, et ce pilote peut empêcher
                                l’affichage
                                de l’icône <b>Mixage stéréo</b> sur certains ordinateurs.
                            </p>
                            <p>Si vous êtes dans ce cas, remplacez le pilote audio par défaut par celui de votre carte
                                mère.
                                Ce pilote doit se trouver sur le CD de pilotes fourni
                                avec votre ordinateur. Si vous n’avez aucun CD de pilotes, rendez-vous sur le site Web
                                du
                                constructeur de l’ordinateur ou de la carte mère.
                            </p>
                            <p>Si vous ne savez pas quel est le nom de votre carte mère, cliquez sur <b>Démarrer</b> ou
                                appuyez sur la touche <i>Windows</i> du clavier, tapez <i>cmd </i>
                                et cliquez sur <b>Invite de commandes</b> dans la partie supérieure du
                                menu <b>Démarrer</b>.
                                Une fenêtre intitulée <b>Invite de commandes</b> s’affiche.
                            </p>
                            <p>Tapez <i>wmic</i>, puis appuyez sur la touche <i>Entrée</i> du clavier.</p>
                            <p>Tapez <i>baseboard get product</i>, puis appuyez sur la touche <i>Entrée</i> du clavier.
                            </p>
                            <p>Le nom de la carte est affiché dans la fenêtre. Ici par exemple, il s’agit
                                d’une <b>A770CrossFire</b> :
                                <img src={BACKEND_URL + "/images/faq/windows-10-activer-mixage-stereo-5.jpg"}/>
                            </p>
                            <p>Tapez ce nom dans Google et vous aurez tôt fait de trouver le constructeur de la carte et
                                son
                                site Web.
                                Il ne vous reste plus qu’à télécharger le pilote audio correspondant.
                                <img src={BACKEND_URL + "/images/faq/windows-10-activer-mixage-stereo-6.jpg"}/>
                            </p>
                            <p>Pour mettre à jour votre pilote audio, cliquez du bouton droit sur <b>Démarrer</b> et
                                choisissez <b>Gestionnaire de périphériques</b> dans le menu.
                                La fenêtre du gestionnaire de périphériques s’affiche. Développez l’entrée <b>Contrôleurs
                                    audio, vidéo et jeu</b>, cliquez du bouton droit sur l’icône
                                <b> Realtek High Definition Audio</b> (ou équivalent) et choisissez <b>Mettre à jour le
                                    pilote</b> dans le menu :
                                <img src={BACKEND_URL + "/images/faq/windows-10-activer-mixage-stereo-7.jpg"}/>
                            </p>
                            <p>Il ne vous reste plus qu’à désigner le pilote audio que vous avez téléchargé et dézippé
                                pour
                                mettre à jour le pilote actuel.
                                Et à appliquer ce qui a été dit au début de cet article pour faire apparaître
                                l’icône <b>Mixage stéréo</b>.
                            </p>
                        </div>
                    },
                ]
            },
        ],
};


// WEBPACK FOOTER //
// ./src/components/faq/Entries.js